// Generated by ReScript, PLEASE EDIT WITH CARE


let values = [
  "Excel",
  "IsaCompta"
];

function toLabel(value) {
  if (value === "Excel") {
    return "Excel";
  } else {
    return "IsaCompta";
  }
}

function toLowercaseString(value) {
  if (value === "Excel") {
    return "excel";
  } else {
    return "isacompta";
  }
}

function fromString(value) {
  switch (value) {
    case "Excel" :
    case "excel" :
      return "Excel";
    case "IsaCompta" :
    case "isacompta" :
      return "IsaCompta";
    default:
      return;
  }
}

function toSelectItem(value) {
  return {
    TAG: "Option",
    key: toLowercaseString(value),
    label: toLabel(value),
    value: value
  };
}

function isExcel(value) {
  return value === "Excel";
}

function isIsaCompta(value) {
  return value !== "Excel";
}

function equal(a, b) {
  if (a === "Excel") {
    return b === "Excel";
  } else {
    return b !== "Excel";
  }
}

export {
  values,
  toLabel,
  toLowercaseString,
  fromString,
  toSelectItem,
  isExcel,
  isIsaCompta,
  equal,
}
/* No side effect */
